import React from 'react';
import './works.css';
import Portfolio1 from '../../assets/portfolio-1.png';
import Portfolio2 from '../../assets/portfolio-2.png';
import Portfolio3 from '../../assets/portfolio-3.png';
import Portfolio4 from '../../assets/portfolio-4.png';
import Portfolio5 from '../../assets/portfolio-5.png';
import Portfolio6 from '../../assets/portfolio-6.png';

const Works = () => {
  return (
    <section id='works'>
        <h2 className='workstitle'>My Works</h2>
        <span className='worksDesc'>Below, you'll find a showcase of my previous projects and performances through images. You can explore each by clicking on its respective image. </span>
        <div className='worksImgs'>

        
<a href="https://www.linkedin.com/posts/ratanojha_icraimmstel2022-internationalconference-researchpaper-activity-6938021601061789696-1Cg5?utm_source=share&utm_medium=member_desktop" target="_blank" rel="noreferrer">
  <img src={Portfolio4} alt='Researchpaper' className='worksImg' />
  <div class="imgText">Research Papers</div>
</a>
<a href="https://youtu.be/Q6oyoYIu66I?si=FCk69hd1YfJeYDOW" target="_blank" rel="noreferrer">
  <img src={Portfolio2} alt='Anchor' className='worksImg' />
  <div class="imgText">Anchoring</div>
</a>
<a href="https://drive.google.com/drive/folders/1euJs9So8QH3zvBMdmuO-RVXxJ1gCckoB?usp=sharing" target="_blank" rel="noreferrer">
  <img src={Portfolio1} alt='TechEraMagazine' className='worksImg' />
  <div class="imgText">Founder,Editor UGI Tech Era Magazine</div>
</a>

<a href="https://youtu.be/xPl-4wiWX-0?si=Xvz4GiQdKyw8_jaN" target="_blank" rel="noreferrer">
  <img src={Portfolio3} alt='JoshTalks' className='worksImg' />
  <div class="imgText">Organising JoshTalks at College</div>
</a>


<a href="https://youtu.be/1aJcw1VbLAE?si=hngRgpzoyQ7uk2sV" target="_blank" rel="noreferrer">
  <img src={Portfolio5} alt='VillageVlog' className='worksImg' />
  <div class="imgText">My Short Film: Mera Gaon</div>
</a>

<a href="https://youtu.be/8VYrIR9TRe4?si=qtZ9uT1uR75YbMM7" target="_blank" rel="noreferrer">
  <img src={Portfolio6} alt='collegeLife' className='worksImg' />
  <div class="imgText">My Short Film on college Life</div>
</a>

        </div>
        {/* <button className='worksBtn'> See More</button> */}
    </section>
  );
}

export default Works;